// Imports
import { faLock, faUser } from '@fortawesome/pro-solid-svg-icons';
import React from 'react';
import Input from '../../../shareables/foundation/front-end/components/forms/fields/input';
import MultiFieldContainer from '../../../shareables/foundation/front-end/components/forms/multi-field-container';


// Function component
const User: React.FC = () => (
	<React.Fragment>
		<MultiFieldContainer>
			<Input name='firstName' type='text' label='First name' icon={faUser} maxLength={50} autoFocus required />
			<Input name='lastName' type='text' label='Last name' icon={faUser} maxLength={50} required />
		</MultiFieldContainer>
		
		<Input name='password' type='password' label='Password' icon={faLock} data-private showStrength required />
	</React.Fragment>
);

export default User;
